module.exports = __webpack_public_path__ + "media/src/components/GenerateDocument/images/success-circle-a5bbb0c49e0486e4125f97215ab00e6f.png";